import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "./api/api";

const OnboardingRedirector = () => {
  const [redirectPath, setRedirectPath] = useState(null);
  const [loading, setLoading] = useState(true);

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const decideRedirect = async () => {
      try {
        // 1️⃣ Not logged in
        if (!userId) {
          setRedirectPath("/login");
          return;
        }

        // 2️⃣ Get navigation stage from backend
        const res = await api.get(
          `/api/User/GetUserNavigation/${userId}`
        );

        const stage = res?.data?.stage;

        // 3️⃣ Redirect rules
        if (stage < 2) {
          setRedirectPath("/profile");
        } else if (stage === 3) {
          setRedirectPath("/myresume");
        } else {
          // safety fallback
          setRedirectPath("/profile");
        }
      } catch (err) {
        console.error("Redirect check failed", err);
        setRedirectPath("/profile");
      } finally {
        setLoading(false);
      }
    };

    decideRedirect();
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  return <Navigate to={redirectPath} replace />;
};

export default OnboardingRedirector;
